// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___cTOG","select":"styles_select__1ZSJE"};